import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LoginManager } from '../../core/login-manager';

// Pulsante navbar per attivare/nascondere il messaggio di conferma aggiunta
// articolo. Agisce sul flag `hideAddItemConfirm` dell'utente (persistito lato
// server tramite updateProfile). Il flag ha effetto solo per gli agenti
// (livello 1 o 9), quindi il pulsante viene mostrato solo per questi utenti.
const MessageToggle = () => {
    const userInfo = LoginManager.getUserInfo();

    // hidden = true quando il messaggio di conferma è nascosto
    const [hidden, setHidden] = useState(false);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (userInfo) {
            setHidden(parseInt(userInfo.hideAddItemConfirm) === 1);
        }
    }, [userInfo]);

    const toggleMessage = async () => {
        if (saving) return;

        const newHidden = !hidden;
        const newValue = newHidden ? 1 : 0;

        // Aggiornamento ottimistico dell'interfaccia
        setHidden(newHidden);
        setSaving(true);

        try {
            const response = await LoginManager.updateProfile({ hideAddItemConfirm: newValue });
            if (response && response.success === 0) {
                // Rollback in caso di errore lato server
                setHidden(!newHidden);
            } else {
                // Aggiorna lo userInfo in memoria/localStorage così che
                // ItemPreview legga subito il nuovo valore senza reload
                LoginManager.patchUserInfo({ hideAddItemConfirm: newValue });
            }
        } catch (e) {
            setHidden(!newHidden);
        } finally {
            setSaving(false);
        }
    };

    // Mostra il pulsante solo per gli agenti (livello 1 o 9)
    if (!userInfo || (parseInt(userInfo.level) !== 1 && parseInt(userInfo.level) !== 9)) {
        return null;
    }

    return (
        <Button
            variant="outline-light"
            size="sm"
            onClick={toggleMessage}
            disabled={saving}
            className="theme-toggle-btn me-2"
            title={hidden ? 'Mostra messaggio di conferma aggiunta articolo' : 'Nascondi messaggio di conferma aggiunta articolo'}
        >
            <FontAwesomeIcon
                icon={hidden ? 'comment-slash' : 'comment'}
                className="theme-toggle-icon"
            />
        </Button>
    );
};

export default MessageToggle;
